export const version = () => {
  return process.env.REACT_APP_SITE_VERSION === "euxp" ? "EUXP" : "GBXP"
}

export const versionEmail = () => {
  return process.env.REACT_APP_SITE_VERSION === "euxp" ? "euxp.eu" : "gbxp.uk"
}
